<template>
    <div id="dispatchManage" class="clearfix">
        <div class="section secLeft">
            <div class="clearfix">
                <p class="fl" style="line-height: 40px">检索条件：</p>
                <el-button type="text" @click="clearFrom" class="fr" style="width: 60px;color: #169BD5;">重置</el-button>
            </div>
            <el-form ref="searchForm" :model="searchForm" class="search-form" >
                <div class="form-item">
                    <el-form-item style="margin-bottom:5px">
                        <el-select filterable size="small" clearable v-model="searchForm.brandId" placeholder="品牌" @change="choseBrand" >
                            <el-option v-for="(item,index) in brandList" :key="index" :label="item.brandName" :value="item.brandId">{{item.brandName}}</el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item style="margin-left:3px;margin-bottom:5px">
                        <el-select filterable size="small" clearable v-model="searchForm.categoryId"  placeholder="品类" @change="choseCategory">
                            <el-option v-for="(item,index) in categoryList" :selected="{'selected':index==0}" :key="index" :label="item.categoryName" :value="item.categoryId">{{item.categoryName}}</el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item style="margin-left:3px;margin-bottom:5px">
                        <el-select filterable size="small" clearable v-model="searchForm.modelId"  placeholder="型号" @change="choseModel">
                            <el-option v-for="(item,index) in modelList" :selected="{'selected':index==0}" :key="index" :label="item.modelName" :value="item.modelId">{{item.modelName}}</el-option>
                        </el-select>
                    </el-form-item>
                </div>
                <div class="form-item">
                    <el-select filterable clearable size="small" style="margin-bottom:5px"  v-model="searchForm.faultSubclassId" filterable placeholder="故障">
                        <el-option
                            v-for="(item,index) in faultopeList"
                            :key="index"
                            :label="item.faultSubclassName"
                            :value="item.faultSubclassId">
                        </el-option>
                    </el-select>
                    <el-select  filterable clearable size="small" style="margin-left:3px;margin-bottom:5px" v-model="searchForm.serviceType" filterable placeholder="订单类型">
                        <el-option
                            v-for="(item,index) in orderTypeList"
                            :key="index"
                            :label="item.paraName"
                            :value="item.paraValue">
                        </el-option>
                    </el-select>
                    <el-select filterable clearable size="small" style="margin-left:3px;margin-bottom:5px" v-model="searchForm.adminStatus" filterable placeholder="订单状态">
                        <el-option
                            v-for="(item,index) in orderStatusList"
                            :key="index"
                            :label="item.paraName"
                            :value="item.paraValue">
                        </el-option>
                    </el-select>
                </div>
                <div class="form-item">
                    <el-input clearable size="small" v-model.trim="searchForm.name" placeholder="请输入工程师姓名" style="margin-bottom: 5px"></el-input>
                    <el-input clearable size="small" v-model.trim="searchForm.number" placeholder="请输入工程师账号" style="margin-left:3px;margin-bottom:5px;"></el-input>
                </div>
                <el-date-picker
                    @change="changePicker"
                    size="small"
                    style="margin-bottom: 15px;width: 100%; font-size : 5px"
                    v-model="value5"
                    type="datetimerange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期">
                </el-date-picker>
                <el-button type="primary" @click="onSubmit" :loading="isSearch"  style="width: 100%;">检索</el-button>
            </el-form>
            <div class="clearfix"></div>
            <div style=" height:630px; overflow-y:auto;padding:3px"> 
                <ul style="box-shadow:3px 3px 5px #ddd;border:1px dashed #eee">
                    <li v-for="(item,index) in orderLists" :key="index" class="orderLi" :class="{activeOrderLi:activeIndex===index}" @click="selectOrder(item,index)">
                        <dl>
                            <dt>
                                <ul class="orderStutasUl">
                                    <li class="orderStutasLi fl" v-if="item.modelName != null || item.colorName != null" >{{item.modelName}} {{item.colorName}}</li>
                                    <li class="orderStutasLi fl" v-for="(items,indexs) in item.faultSubclass" :key="indexs">
                                        <span v-if="items != null && items.faultSubclassName!=  null"> {{items.faultSubclassName}} </span>
                                    </li>
                                    <li class="orderStutasLi fl" > {{item.serviceType | sysCodeFileter('order_type') }}</li>
                                    <li class="fl">
                                        <i v-if="item.isTag == 1" class="el-icon-caret-top" style="color:#409EFF;font-size:24px" @click="setOrderTagOpe(item , 0)"></i>
                                        <i v-else  class="el-icon-caret-top" style="font-size:24px" @click="setOrderTagOpe(item , 1)"></i>
                                    </li>
                                    <li class="fl">
                                        <i v-if="item.isTag == -1" class="el-icon-caret-bottom" style="color:#409EFF;font-size:24px" @click="setOrderTagOpe(item , 0)"></i>
                                        <i v-else  class="el-icon-caret-bottom" style="font-size:24px" @click="setOrderTagOpe(item , -1)"></i>
                                    </li>
                                </ul>
                            </dt>
                        </dl>
                        <dl>
                            <dt>工单编号:</dt>
                            <dd>{{item.orderNo}}</dd>
                            <dd class="orderStutasLiN">{{item.adminStatus | sysCodeFileter('admin_status')}}</dd>
                        </dl>
                        <dl>
                            <dt>详细地址:</dt>
                            <dd>{{item.countyName}}{{item.address}}</dd>
                        </dl>
                        <dl>
                            <dt>预约时间:</dt>
                            <dd>{{item.onsiteDate}} {{item.onsiteTimeStart}}~{{item.onsiteTimeEnd}}</dd>
                        </dl>
                        <dl>
                            <dt>最新回复:</dt>
                            <dd class="ellipsis">{{item.handleRemark}}</dd>
                        </dl>
                        <dl>
                            <dt>工程师:</dt>
                            <dd>{{item.staffName}}</dd>
                            <dd :class="{activeBtn:activeIndex===index}" class="showBtn" v-if="item.adminStatus == 03" @click="queryEgineerOpe1(item)">派单</dd>
                            <dd :class="{activeBtn:activeIndex===index}" class="showBtn" v-if="item.adminStatus == 04 || item.adminStatus == 05 || item.adminStatus == 06 || item.adminStatus == 07" @click="queryEgineerOpe1(item)">重置派单</dd>
                        </dl>
                    </li>
                </ul>
                <!--分页-->
                <el-col class="toolbar" :span="10">
                    <div class="pagination">
                        <el-pagination
                            small
                            background
                            @size-change="handleSizeChangeOrder"
                            @current-change="handleCurrentChangeOrder"
                            :current-page="searchForm.startRow"
                            :page-sizes="[10,20, 50, 100,500,1000]"
                            :page-size="searchForm.pageSize"
                            layout=" total, sizes , prev, pager, next,jumper"
                            :total="orderPage.total">
                        </el-pagination>
                    </div>
                </el-col>
            </div>
        </div>
        <div class="section" style="width:100%;height:100%;padding:5px;">
            <div id="atlas"  style="height: 900px; padding:5px;" ></div>
        </div>
        <div class="section secRight">
            <el-form ref="searchEngineer" :model="searchEngineer" class="clearfix">
                <el-input clearable @input="queryEgineerOpe" v-model.trim="searchEngineer.name" placeholder="搜索工程师" style="margin-bottom: 15px;"></el-input>
            </el-form>
            <ul class="rightContent" style="overflow-y: auto;">
                <li v-for="(item,index) in engineerLists" style="margin-bottom: 2px;padding:20px 0 10px; " :key="index">
                    <div class="enginner-section">
                        <dl>
                            <dt class="name">{{item.name}}</dt>
                            <dd style="padding:0 5px;border-radius: 3px;height:18px;background-color: #1abc9c;color: #fff;margin-right: 5px;" v-if="item.engineerStatus =='DD'">等待</dd>
                            <dd style="padding:0 5px;border-radius: 3px;height:18px;background-color: #1abc9c;color: #fff;margin-right: 5px;" v-if="item.engineerStatus =='YCF'">已出发</dd>
                            <dd style="padding:0 5px;border-radius: 3px;height:18px;background-color: #1abc9c;color: #fff;margin-right: 5px;" v-if="item.engineerStatus =='YDD'">已到达</dd>
                            <dd style="padding:0 5px;border-radius: 3px;height:18px;background-color: #1abc9c;color: #fff;margin-right: 5px;" v-if="item.engineerStatus =='WXZ'">维修中</dd>
                            <dd style="padding:0 5px;border-radius: 3px;height:18px;background-color: #1abc9c;color: #fff;margin-right: 5px;" >{{item.orderCount}}单</dd>
                        </dl>
                        <dl>
                            <dt>当前位置:</dt>
                            <dd>{{item.site}}</dd>
                            <dd class="pointer-content">
                                <el-button v-if="basicsAuth.send_orders" class="pointer" size="mini" @click="changeDispatch(item)">指派</el-button>
                            </dd>
                        </dl>
                    </div>
                </li>
            </ul>
            <el-col style="width:40%" class="toolbar">
                <div class="pagination" >
                    <el-pagination
                        small
                        background
                        @size-change="handleSizeChangeEngineer"
                        @current-change="handleCurrentChangeEngineer"
                        :current-page="engineerPage.startRow"
                        :page-sizes="[2,5,10]"
                        :page-size="engineerPage.pageSize"
                        layout=" total, sizes, prev, pager, next"
                        :total="engineerPage.total">
                    </el-pagination>
                </div>
            </el-col>
        </div>
    </div>
</template>
<script>
    import Vue from 'vue'
    import draggable from 'vuedraggable'
    import { BmlLushu } from 'vue-baidu-map'
    import { TMap } from '@/api/parking'
    import {selectFault , querySendOrderList , selectWorkOrder  , queryEgineer , setOrderTag , assignFetcher ,assignDeliveryman , sendOrders ,revertSendOrders } from '../../api/order'
    import {
        inventoryList,inventorySerial,selectParameterInfoBusiness,selectMaterialClassifications,
        selectAllBrand,selectCategory,selectModel
    } from "../../api/api";
     import {getPermission} from '../../api/authRequest'
    import { getAllSysCode } from '@/api/system'
    export default {
        name: 'dispatchManage',
        components: {
            BmlLushu,draggable
        },
        data () {
            return {
                value1:'',
                modelId:null,
                isSearch: false,
                visible2: false,
                radio:'',
                play: true,
                isTagNow:false,
                path: [],
                icon: {
                    url: 'http://api.map.baidu.com/library/LuShu/1.2/examples/car.png',
                    size: { width: 52, height: 26 },
                    opts: { anchor: { width: 27, height: 13 }}
                },
                activeIndex:null,
                orderLists:[],
                checkRadio:'1',
                map : null,
                searchEngineer:{},
                engineerLists:[],
                searchForm:{
                    startRow : 1,
                    pageSize : 10,
                    name: '',
                    number: '',
                    onsiteDateStarts:'',
                    onsiteDateEnds:'',
                    adminStatus:"03"
                },
                value4: ['', ''],
                choose:{},
                dataList:[],
                sendOrder:null,
                sendEnginner:null,
                brandList:[],       //品牌数组
                categoryList:[],    //品类数组
                modelList:[],       //型号数组
                orderTypeList : [],
                orderStatusList:[],
                faultopeList:[],
                txOrders:[],
                txEngineer:[],
                orderPage:{},
                engineerPage:{},
                value5:[],
                basicsAuth:{
                    send_orders:false
                }
            }
        },
        mounted () {
             this.basicsAuth.send_orders= getPermission('/api/workOrder/order/send_orders');
        },
        created(){
            var myDate = new Date();
            var year = myDate.getFullYear(); 
            var  month = myDate.getMonth(); 
            var date = myDate.getDate(); 
            this.value1 = year +  "-" + (month+1) + "-" + date
            var start = new Date(year, month, date, 8)
            var end = new Date(year, month, date, 23)
            this.value4[0] = start
            this.value4[1] =  end
            this.value5[0] = new Date(year, month, date, 8)
            this.value5[1] = new Date(year, month, date, 23)
            this.mapTX();
            this.queryEgineerOpe()
            this.getBrandList()      //请求机型品牌数据
            this.getAllOrderType()
            this.getAllOrderStatus()
            this.selectFaultOpe()
        },
        methods: {
            changePicker(e){
                console.log(e)
                if(e == null){
                    this.searchForm.onsiteDateStarts = "";
                    this.searchForm.onsiteDateEnds = "";
                }
            },
            handleSizeChangeEngineer(val){
                this.searchEngineer.pageSize = val
                this.queryEgineerOpe()
            },
            handleCurrentChangeEngineer(page){
                this.searchEngineer.startRow = page
                this.queryEgineerOpe()
            },
            handleSizeChangeOrder(val){
                this.searchForm.pageSize = val
                this.onSubmit();
            },
            handleCurrentChangeOrder(Page){
                this.searchForm.startRow = Page
                this.onSubmit();
            },
            selectFaultOpe(){
                selectFault().then(res => {
                    if(res.data.results){
                        this.faultopeList =  res.data.results
                    }
                })
            },
            getAllOrderType(){
                getAllSysCode({
                    'startRows' : 1,
                    'pageSize' : 100,
                    'paraType' :'order_type' 
                }).then(resp => {
                    if(resp.data.results){
                        this.orderTypeList = resp.data.results.list
                    }
                }).catch((error) =>{
                    this.$Message.error(error.message);
                })
            },
            getAllOrderStatus(){
                getAllSysCode({
                    'startRows' : 1,
                    'pageSize' : 100,
                    'paraType' :'admin_status' 
                }).then(resp => {
                    if(resp.data.results){
                        this.orderStatusList = resp.data.results.list
                    }
                }).catch((error) =>{
                    this.$Message.error(error.message);
                })
            },
            //机型型号
            getModelList(){
                this.modelId = "";
                // this.searchForm.faultSubclassId = ""
                this.searchForm.modelId  = ""
                let para={
                    brandId:this.searchForm.brandId,
                    categoryId:this.searchForm.categoryId
                };
                selectModel(para).then(res => {
                    if (res.data.status==100) {
                        this.modelList = res.data.results;
                    }else{
                        this.$message({
                            message: res.data.message,
                            type: "error"
                        });
                    }
                }).catch((error) =>{
                    this.$Message.error(error.message);
                })
            },
            //机型品类
            getCategoryList(){
                this.searchForm.categoryId = "";
                this.modelId = "";
                // this.searchForm.faultSubclassId = ""
                this.categoryList = [];
                this.modelList = [];  //清空型号数据
                let para={
                    brandId:this.searchForm.brandId
                };
                selectCategory(para).then(res => {
                    if (res.data.status==100) {
                        this.categoryList = res.data.results;            
                    }else{
                        this.$message({
                            message: res.data.message,
                            type: "error"
                        });
                    }
                }).catch((error) =>{
                    this.$Message.error(error.message);
                })
            },
            //机型品牌
            choseBrand(e){
                this.getCategoryList();
            },
            choseCategory(e){
                this.getModelList();
            },
            choseModel(){
                //  this.searchForm.faultSubclassId = ""
            },
            getBrandList(){
                selectAllBrand().then(res => {
                    if (res.data.status==100) {
                        this.brandList = res.data.results;
                    }else{
                        this.$message({
                            message: res.data.message,
                            type: "error"
                        });
                    }
                }).catch((error) =>{
                    this.$Message.error(error.message);
                })
            },
            setOrderTagOpe(order , tag){
                if(this.isTagNow){
                    this.$message({
                        message: '正在处理请稍后！',
                        type: 'error'
                    })
                    return
                }
                this.isTagNow = true
                let param = {
                    orderId : order.id,
                    tag : tag
                }
                setOrderTag(param).then(res =>{
                    if(res.data.status==100){
                        this.isTagNow = false
                        this.$message({
                            message: '操作成功',
                            type: 'success'
                        });
                        this.onSubmit();
                    }else{
                        this.isTagNow = false
                        this.$message({
                            message: '操作失败',
                            type: 'error'
                        });
                    }
                    this.isTagNow = false
                })

            },
            queryEgineerOpe(){
                if(this.txEngineer){
                    for(let i = 0 ;i< this.txEngineer.length ; i++){
                        this.txEngineer[i].setMap(null)
                    }
                }
                queryEgineer(this.searchEngineer).then(res => {
                    if(this.txEngineer){
                        for(let i = 0 ;i< this.txEngineer.length ; i++){
                            this.txEngineer[i].setMap(null)
                        }
                    }
                    if(res.data.status == '100'){
                        this.engineerPage = res.data.results
                        this.engineerLists = res.data.results.list
                        for(let i = 0 ; i<this.engineerLists.length; i++ ){
                            var marker = new qq.maps.Label({
                                position: new qq.maps.LatLng(this.engineerLists[i].latitude, this.engineerLists[i].longitude),
                                // position: new qq.maps.LatLng(31.20885, 121.42396),
                                map: this.map,
                                content: this.engineerLists[i].name,
                                style:{backgroundColor:"#EE7942"},
                                offset: new qq.maps.Size(0, 2)
                            });
                            this.txEngineer.push(marker)
                        }
                    }
                })
            },
            //查询可派单工程师
            queryEgineerOpe1(item){
                console.log(item)
                if(this.txEngineer){
                    for(let i = 0 ;i< this.txEngineer.length ; i++){
                        this.txEngineer[i].setMap(null)
                    }
                }
                this.searchEngineer.brandId = item.brandId;
                this.searchEngineer.categoryId = item.categoryId;
                this.searchEngineer.modelId = item.modelId;
                this.searchEngineer.colorId = item.colorId;
                this.searchEngineer.provinceId = item.province;
                this.searchEngineer.faultSubclass = item.faultSubclass;
                this.getEgineerList();
                
            },
            //查询工程师
            getEgineerList(){
                queryEgineer(this.searchEngineer).then(res => {
                    if(this.txEngineer){
                        for(let i = 0 ;i< this.txEngineer.length ; i++){
                            this.txEngineer[i].setMap(null)
                        }
                    }
                    if(res.data.status == '100'){
                        this.engineerPage = res.data.results
                        this.engineerLists = res.data.results.list
                        for(let i = 0 ; i<this.engineerLists.length; i++ ){
                            if(null != this.engineerLists[i].latitude && null != this.engineerLists[i].longitude){
                                var marker = new qq.maps.Label({
                                    position: new qq.maps.LatLng(this.engineerLists[i].latitude, this.engineerLists[i].longitude),
                                    // position: new qq.maps.LatLng(31.20885, 121.42396),
                                    map: this.map,
                                    content: this.engineerLists[i].name,
                                    style:{backgroundColor:"#EE7942"},
                                    offset: new qq.maps.Size(0, 2)
                                });
                                this.txEngineer.push(marker)
                            }
                        }
                    }
                })
            },
            mapTX() {
                TMap().then(qq => {
                    this.map = new qq.maps.Map(document.getElementById('atlas'), {
                        //这里经纬度代理表进入地图显示的中心区域
                        center: new qq.maps.LatLng(31.20885, 121.42396),
                        zoom: 15
                    })
                })
            },
            reset() {
                this.play = false
            },
            handleSearchComplete(res) {
                this.path = res.getPlan(0).getRoute(0).getPath()
            },
            //
            selectOrder(item,index){
                this.activeIndex = index
                item.showBtn = true
                this.sendOrder = item 
            },
            changeDispatch(engineer){
                this.$confirm('是否确认指派订单?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    if(null == this.sendOrder ){
                        this.$message({
                            message: '请选择订单',
                            type: 'error'
                        });
                        this.visible2 = false
                        return;
                    }
                    let query = {
                        id: this.sendOrder.id,
                        engineerId: this.sendEnginner.id
                    }
                    // 如果订单为挂起 重置派单
                    if(this.sendOrder.adminStatus == '04'  || this.sendOrder.adminStatus == '05' || this.sendOrder.adminStatus == '06' || this.sendOrder.adminStatus == '07'   ){
                        revertSendOrders(query).then(res => {
                            if(res.data.status == '100'){
                                this.$message({
                                    message: '成功',
                                    type: 'success'
                                });
                                this.selectOrder = null
                                this.sendEnginner = null
                                this.onSubmit();
                                // this.queryEgineerOpe();
                                this.getEgineerList()
                            }else{
                                this.selectOrder = null
                                this.sendEnginner = null
                                this.$message({
                                    message: '失败',
                                    type: 'error'
                                });
                            }
                        }).catch((error) =>{
                            this.$Message.error(error.message);
                        })
                    // 如果订单状态为 如果如果订单状态为：  待派单（03） ，  待维修入库（32） ， 指派订单
                    }else if(this.sendOrder.adminStatus == '03'  ){
                            sendOrders(query).then(res => {
                                if(res.data.status == '100'){
                                    this.$message({
                                        message: '成功',
                                        type: 'success'
                                    });
                                    this.selectOrder = null
                                    this.sendEnginner = null
                                    this.onSubmit();
                                    this.queryEgineer();
                                }else{
                                    this.selectOrder = null
                                    this.sendEnginner = null
                                        this.$message({
                                            message: '失败',
                                            type: 'error'
                                        });
                                    }

                            }).catch((error) =>{
                                this.$Message.error(error.message);
                            })
                    // 如果订单为 取机单， 而且未取机，   订单状态为：  待派单（03）  取机
                    }else if( (this.sendOrder.serviceType == "QJ" || this.sendOrder.serviceType == "QS") 
                        && this.sendOrder.isFetch == 0 &&  this.sendOrder.adminStatus == '03'  ){ 
                            assignFetcher(query).then(res =>{
                                if(res.data.status == '100'){
                                    this.$message({
                                        message: '成功',
                                        type: 'success'
                                    });
                                    this.selectOrder = null
                                    this.sendEnginner = null
                                    this.onSubmit();
                                    this.queryEgineer();
                                }else{
                                    this.selectOrder = null
                                    this.sendEnginner = null
                                    this.$message({
                                        message: '失败',
                                        type: 'error'
                                    });
                                }
                            }).catch((error) =>{
                                this.$Message.error(error.message);
                            })
                    //如果订单状态为维修完成待派 38  songji 
                    }else if(this.sendOrder.adminStatus == '38' ){ 
                        assignDeliveryman(query).then(res =>{
                            if(res.data.status == '100'){
                                this.$message({
                                    message: '成功',
                                    type: 'success'
                                });
                                this.selectOrder = null
                                this.sendEnginner = null
                                this.onSubmit();
                                this.queryEgineer();
                            }else{
                                this.selectOrder = null
                                this.sendEnginner = null
                                this.$message({
                                    message: '失败',
                                    type: 'error'
                                });
                            }
                        }).catch((error) =>{
                            this.$Message.error(error.message);
                        })
                    }else{
                        this.$message({
                            message: '订单状态错误',
                            type: 'error'
                        });
                    }          
                }).catch(() => {
                    this.visible2 = false
                    this.$message({
                        type: 'info',
                        message: '已取消'
                    });          
                });
                this.sendEnginner = engineer
            },
            refresh() {
                // alert(2121212)
            },
            onSubmit() {
                this.isSearch = true
                if(this.value5 != null){
                    this.searchForm.onsiteTimeStarts = this.value5[0];
                    this.searchForm.onsiteTimeEnds = this.value5[1];
                }
                this.searchForm.modelId = this.modelId
                if(this.txOrders){
                    for(let i = 0 ;i< this.txOrders.length ; i++){
                        this.txOrders[i].setMap(null)
                    }
                }
                querySendOrderList(this.searchForm).then(res =>{
                    this.isSearch = false

                    if(res.data.status == '100'){
                        this.orderPage = res.data.results
                        this.orderLists = res.data.results.list
                        //设置订单的位置
                        for(let i = 0 ; i<  this.orderLists.length ; i++){
                            var marker = new qq.maps.Label({
                                position: new qq.maps.LatLng(this.orderLists[i].latitude, this.orderLists[i].longitude),
                                map: this.map,
                                content:   this.getOrderStatus(this.orderLists[i].adminStatus)  + "   " + this.orderLists[i].onsiteTimeStart + "~" +this.orderLists[i].onsiteTimeEnd,
                                style : {backgroundColor : "#97FFFF"},
                                offset: new qq.maps.Size(0, -2)
                            });
                            this.txOrders.push(marker)
                        }
                    }else{
                        this.$Message.error(res.message);
                    }
                }).catch((error) =>{
                    this.$Message.error(error.message);
                })
            },
            clearFrom(){
                var myDate = new Date();
                var year = myDate.getFullYear(); 
                var  month = myDate.getMonth() + 1; 
                var date = myDate.getDate(); 
                var start = new Date(year, month, date, 8)
                var end = new Date(year, month, date, 23)
                this.value4 = []
                this.value4[0] = start
                this.value4[1] =  end
                this.value5 = []
                this.value5[0] = new Date(year, month, date, 8)
                this.value5[1] = new Date(year, month, date, 23)

                this.searchForm = {}
                this.modelId = ""
                this.searchForm.onsiteDateEnds = ""
                this.searchForm.onsiteDateStarts = ""

                this.searchForm = {}
                this.value1 =  year +"-" + month + "-" + date
                // this.value4 = []
            },
            getOrderStatus(status){
                if(status ==  '01'){
                    return '待确认'
                }else if(status ==  '02' ){
                    return '无法确认'
                }else if(status ==  '03' ){
                    return '待派单'
                }else if(status ==  '04' ){
                    return '挂起'
                }else if(status ==  '05' ){
                    return '待出发'
                }else if(status ==  '06' ){
                    return '待到达'
                }else if(status ==  '07' ){
                    return '已到达'
                }else if(status ==  '08' ){
                    return '维修中'
                }else if(status ==  '09' ){
                    return '待送机'
                }else if(status ==  '10' ){
                    return '取消维修中'
                }else if(status ==  '11' ){
                    return '取机中'
                }else if(status ==  '12' ){
                    return '取机完成'
                }else if(status ==  '13' ){
                    return '已完成'
                }else if(status ==  '14' ){
                    return '已取消'
                }else if(status ==  '30' ){
                    return '待到店'
                }else if(status ==  '31' ){
                    return '待维修待入库'
                }else if(status ==  '32' ){
                    return '待维修入库'
                }else if(status ==  '33' ){
                    return '待维修待派'
                }else if(status ==  '34' ){
                    return '待维修已派'
                }else if(status ==  '35' ){
                    return '待维修出库'
                }else if(status ==  '36' ){
                    return '待维修入库'
                }else if(status ==  '37' ){
                    return '维修后待处理'
                }else if(status ==  '38' ){
                    return '维修后待派'
                }else if(status ==  '39' ){
                    return '维修后已派'
                }else if(status ==  '40' ){
                    return '维修完成出库'
                }else if(status ==  '41' ){
                    return '转单天玄'
                }else if(status ==  '42' ){
                    return '已转天玄'
                }
            }
        },
        computed: {
        },
        watch: {
          
        }
    }
</script>

<style lang="scss" type="text/css" scoped>
    #dispatchManage{
        font-size: 14px;
        display:flex;
        .secLeft{
            width:550px;
            margin-right:10px;
        }
        .secRight{
            width:550px;
            padding:3px 3px 3px 13px;
            ul.rightContent{
                box-shadow:3px 3px 5px #eee;
                padding:0 10px;
                border:1px dashed #ddd;
                li{
                    border-top:1px dashed #ddd;
                    .enginner-section{
                        dl{
                            display:flex;
                            position:relative;
                            dt,dd{
                                font-size:12px;
                                margin-bottom:5px
                            }
                            dd{
                                margin-left:10px
                            }
                            dt.name{
                                font-size:14px;
                            }
                            dd.pointer-content{
                                position:absolute;
                                right:0;
                                top:0;
                                .pointer{
                                    padding: 5px;
                                    border-radius: 3px; 
                                    margin:0 2px 5px 0;
                                    font-size:12px;
                                }
                            }

                        }
                    }
                }
                li:nth-child(1){
                    border-top:none
                }
            }
        }
        .form-item{
            display:flex
        }
        .el-input{
            width:100%
        }
        .headerT{
            margin:0 0 10px 0;
            width: 80px;
        }
        .el-date-editor .el-range-input {
            width: 35%;
        }
        .el-date-editor .el-range-separator {
            width: 8%;
        }
        .orderLi{
            background-color: #fff;
            padding:10px;
            border:1px solid #fff;
            cursor: pointer;
            .orderStutasLi{
                padding: 5px;
                background-color:#1abc9c;
                border-radius: 3px; 
                color:#fff;
                margin:0 2px 5px 0;
                font-size:12px;
            }
            dl{
                display:flex;
                position:relative;
                dd{
                    margin-left:5px;
                }
                dt,dd{
                    margin-bottom:2px;
                    font-size:12px
                }
                dd.ellipsis{
                    width:220px;
                    overflow:hidden;
                    white-space:nowrap;
                    text-overflow:ellipsis;
                }
                
            }
        }
        .orderStutasLiN{
            padding:5px;
            background-color:#1abc9c;
            border-radius: 3px;
            color:#fff;
            margin:0 2px 5px 0 ;
            position:absolute;
            right:0;
            top:0

        }
        .el-icon-star-on{
            color:#409EFF!important;
            font-size:20px;
            margin-top:5px;
            margin-left:10px
        }
        .el-icon-star-off{
            font-size:20px;
            margin-top:5px;
            margin-left:10px
        }
        .activeOrderLi{
            border-color:#1abc9c;
        }
        .map {
            width: 100%;
            height: 800px;
        }
        .showBtn{
            width:auto;
            border-radius: 3px;
            background-color: #f04844;
            color:#fff;
            padding:5px;
            cursor: pointer;
            display: none;
            position:absolute;
            right:0;
            top:0;
            font-size:12px!important
        }
        .activeBtn{
            display: block;
            font-size:12px!important
        }
    }
</style>



// WEBPACK FOOTER //
// dispatchManage.vue?7dbc27fd